import ReactDOM from 'react-dom';
import $ from 'jquery';
import React from "react";
import {AJAX, hidePreloader, showPreloader} from "../functions";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";

export function getTermsConditions() {
	let params = {
		action: 'api/booking/get_terms_conditions'
	};
	AJAX(bf_ajax_url, 'POST', params, {
		response_json: true,
		func_callback: function (resp) {
			if (resp.success === 1 && resp.terms_conditions.length) {
				window.terms_conditions = resp.terms_conditions;
			}
			else
				window.terms_conditions = '';
		},
		func_error: function (resp) {
			window.terms_conditions = '';
		}
	});
}

export function getRentalCarPrices(booking, func_callback, t) {
	let params = {
		action: 'api/booking/get-prices',
		hire: booking.hire,
		vehicle: ''
	};

	if (booking.vehicle !== undefined && booking.vehicle.length > 0) {
		params.vehicle = booking.vehicle;
		if (booking.hire !== 'interstate') {
			params.alternative_location = (booking.alternative_location !== undefined) ? booking.alternative_location : '';
			params.alternative_pickupdate = (booking.alternative_pickupdate !== undefined) ? booking.alternative_pickupdate : '';
			params.alternative_dropoffdate = (booking.alternative_dropoffdate !== undefined) ? booking.alternative_dropoffdate : '';
		}
	}

	AJAX(bf_ajax_url, 'POST', params, {
		response_json: true,
		func_waiting: function () {
			showPreloader();
		},
		func_callback: function (resp) {
			if (resp.success && resp.prices) {
				func_callback(resp, t);
			}
//			console.log(resp);
			hidePreloader();
		},
		func_error: function (resp) {
			hidePreloader();
			showPopupWithGoBack(resp.message);
		}
	});
}

export function ucFirst(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function gTagClickEventValue(event_name, event_params) {
	if (typeof gtag === 'function') {
		gtag('event', event_name, event_params);
	}
}
window.gTagClickEventValue = gTagClickEventValue;

export function showLoadingPayment() {
	$("#id_loading_payment").css('display', 'block');
}
window.showLoadingPayment = showLoadingPayment;

export function hideLoadingPayment() {
	$("#id_loading_payment").css('display', 'none');
}
window.hideLoadingPayment = hideLoadingPayment;


